import type { DirectusUser } from '~~/types';

export function getUserLabel (user: DirectusUser | null | undefined): string {
  if (!user || typeof user !== 'object') {
    return '';
  }

  const parts = [];

  if (user.first_name) {
    parts.push(user.first_name);
  }

  if (user.middle_name) {
    parts.push(user.middle_name);
  }

  if (user.last_name) {
    parts.push(user.last_name);
  }

  if (user.title) {
    parts.unshift(user.title)
  }

  let label = parts.join(' ');

  return label;
}

/**
 * Wie `getUserLabel()`, aber mit dem zweiten Vornamen auf den ersten
 * Buchstaben gekürzt (z.B. "Maximilian J. Muster") — für die Unterschrift auf
 * dem Mitarbeiterausweis, wo nur Vor- und Nachname ausgeschrieben werden.
 */
export function getUserSignatureName (user: DirectusUser | null | undefined): string {
  if (!user || typeof user !== 'object') {
    return '';
  }

  const parts = [];

  if (user.first_name) {
    parts.push(user.first_name);
  }

  if (user.middle_name) {
    parts.push(`${user.middle_name.trim().charAt(0)}.`);
  }

  if (user.last_name) {
    parts.push(user.last_name);
  }

  if (user.title) {
    parts.unshift(user.title)
  }

  return parts.join(' ');
}
